import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function StatusInfo() {
    return (
        <OnboardingBody title='What is an agent status?'>
            <div>
                <p>
                    Your agent status controls whether or not you’re available to receive new
                    incoming chat messages.
                    <br />
                    <br />
                    You can set your agent status to ‘available’ or ‘not accepting chats’ to help
                    manage customer interactions effectively.
                </p>
            </div>
        </OnboardingBody>
    );
}
